// extracted by mini-css-extract-plugin
export default {"spinner_container":"Loader_spinner_container__MLVg4","spinner":"Loader_spinner__4Opo0","spinner-d3wgkg":"Loader_spinner-d3wgkg__KViTS"};